import config from 'config';
import { sendRequest, getEndpoint } from '@/http/clients/fetch.js';
import { getFetchArguments, getFormFetchArguments } from '@/http/clients/auth-service-config.js';

const ADMIN_SSO_GRANT_TYPE = 'urn:viafoura:params:oauth:grant-type:admin-sso';

function getAuthEndpoint(path, method, queryParams) {
    return getEndpoint(config.authServiceUrl, path, method, queryParams);
}

export function authorizeUser(body) {
    const endpoint = getAuthEndpoint('/authorize', 'POST');
    const fetchArgs = getFetchArguments(endpoint, null, body);
    return sendRequest(fetchArgs);
}

export function configureMfa(body) {
    const endpoint = getAuthEndpoint('/users/mfa', 'POST');
    const fetchArgs = getFetchArguments(endpoint, null, body);
    return sendRequest(fetchArgs);
}

/**
 * Exchanges the authorization code Cognito delivered to the SSO callback for a Viafoura session
 * (CM-1805).
 *
 * The SPA never contacts Cognito. It carries the code here, and auth-service performs the exchange
 * server-side with the confidential client's secret — which is why the code alone is worthless to
 * anyone who intercepts it.
 */
export function exchangeAdminSsoCode(sectionUuid, code, state) {
    const endpoint = getAuthEndpoint('/v3/sections/{sectionUuid}/oauth2/token', 'POST');
    const fetchArgs = getFormFetchArguments(endpoint, { sectionUuid }, {
        grant_type: ADMIN_SSO_GRANT_TYPE,
        code,
        state,
    });
    return sendRequest(fetchArgs);
}
